<script setup lang="ts">
import type { ManualImage } from "../../composables/useUserManual.ts";

defineProps<{
    image: ManualImage | null;
}>();

const emit = defineEmits<{
    close: [];
}>();

function onVisibleChange(visible: boolean) {
    if (!visible) {
        emit("close");
    }
}
</script>

<template>
    <Dialog
        id="user-manual_dialog_image-zoom"
        data-cy="user-manual-image-zoom"
        :visible="image !== null"
        :header="image?.alt"
        modal
        :dismissable-mask="true"
        :draggable="false"
        :style="{ width: '95vw', maxWidth: '1600px' }"
        @update:visible="onVisibleChange"
    >
        <img v-if="image" class="manual-image-zoom" :src="image.src" :alt="image.alt" />
    </Dialog>
</template>

<style scoped>
.manual-image-zoom {
    display: block;
    max-width: 100%;
    max-height: 80vh;
    margin: 0 auto;
}
</style>
